/**
 * @fileoverview Reusable field display component for detail modals
 */
import React from "react";
import PropTypes from "prop-types";
import { Typography, Grid } from "@mui/material";

/**
 * Field display component for view mode
 */
export const DmsInfoField = ({ label,
  value = null,
  xs = 6,
  sm = 4,
  md = undefined}) => (
  <Grid item xs={xs} sm={sm} md={md}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="body1">{value || "-"}</Typography>
  </Grid>
);

DmsInfoField.propTypes = {
  /** Field label */
  label: PropTypes.string.isRequired,
  /** Field value */
  value: PropTypes.node,
  /** Grid xs size */
  xs: PropTypes.number,
  /** Grid sm size */
  sm: PropTypes.number,
  /** Grid md size */
  md: PropTypes.number,
};

export default DmsInfoField;
